import { render } from "./single-airtime.vue?vue&type=template&id=07037fff&scoped=true"
import script from "./single-airtime.vue?vue&type=script&lang=js"
export * from "./single-airtime.vue?vue&type=script&lang=js"

import "./single-airtime.vue?vue&type=style&index=0&id=07037fff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07037fff"]])

export default __exports__